import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "100%",
  },
}));

const DatePickers = (props) => {
  const classes = useStyles();
  const value = props.value.slice(0,4) + "-" + props.value.slice(4,6) + "-" + props.value.slice(6,8)

  return (
    <form className={classes.container} noValidate>
      <TextField
        id="date"
        label="Birthday"
        type="date"
        value={value}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        onChange={e => {
          const birthday = e.target.value.replace(/-/g, '');
          props.onChange({birthday: birthday})
        }}
      />
    </form>
  );
}

export default DatePickers